import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Heart, Award, BookOpen } from "lucide-react";

const sections = [
  {
    icon: BookOpen,
    title: "تاريخ العائلة",
    text: "تمتد جذور عائلتنا عبر أجيال عديدة، حيث حافظ أجدادنا على القيم النبيلة والتقاليد الأصيلة التي ورثناها وننقلها للأجيال القادمة.",
  },
  {
    icon: Award,
    title: "إنجازات العائلة",
    text: "على مر السنين، حقق أفراد العائلة إنجازات متميزة في مختلف المجالات، مما يعكس التزامهم بالتفوق والعطاء للمجتمع.",
  },
  {
    icon: Heart,
    title: "قيم العائلة",
    text: "نؤمن بالتكاتف والتراحم بين أفراد العائلة، ونحرص على تعزيز الروابط العائلية والحفاظ على تراثنا العريق.",
  },
];

const About = () => {
  return (
    <div className="min-h-screen pt-24 pb-12 px-4">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="font-amiri text-4xl md:text-5xl font-bold gold-text mb-4">عن عائلة أبوليلة</h1>
          <div className="w-24 h-[2px] gold-gradient rounded-full mx-auto" />
        </motion.div>

        <div className="grid gap-8">
          {sections.map((section, i) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, x: i % 2 === 0 ? 30 : -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.2 }}
            >
              <Card className="glass-card border-primary/10 hover:border-primary/30 transition-colors">
                <CardContent className="p-8 flex gap-6 items-start">
                  <div className="p-3 rounded-lg bg-primary/10 shrink-0">
                    <section.icon className="h-8 w-8 text-primary" />
                  </div>
                  <div>
                    <h2 className="font-amiri text-2xl font-bold text-primary mb-3">{section.title}</h2>
                    <p className="text-muted-foreground leading-relaxed text-lg">{section.text}</p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
